import type { SVGProps } from 'react';

export const TextBoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2002 3.59961C15.8511 3.59971 18 5.74943 18 8.40039C17.9999 9.57607 17.5758 10.6518 16.874 11.4863C18.2676 12.3262 19.2001 13.8539 19.2002 15.5996C19.2002 18.2505 17.0512 20.4002 14.4004 20.4004H8.40039C7.07489 20.4004 6 19.3255 6 18V6C6 4.6745 7.07489 3.59961 8.40039 3.59961H13.2002ZM8.40039 18H14.4004C15.7257 17.9998 16.7998 16.925 16.7998 15.5996C16.7996 14.2744 15.7256 13.2004 14.4004 13.2002H8.40039V18ZM8.40039 10.7998H13.2002C14.5255 10.7997 15.5994 9.72568 15.5996 8.40039C15.5996 7.07492 14.5256 6.00011 13.2002 6H8.40039V10.7998Z"
      fill="currentColor"
    />
  </svg>
);
